import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TranslateModule } from '@ngx-translate/core';
import { CapitalizeFirstPipe } from './pipes/capitalize-first.pipe';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './interceptors/loader-interceptor.service';
import { LogInterceptor } from './interceptors/log-interceptor.service';
import { RequestInterceptor } from './interceptors/request-interceptor.service';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule.forChild()
	],
	declarations: [
		PageNotFoundComponent,
		CapitalizeFirstPipe,
		HeaderComponent,
		FooterComponent
	],
	exports: [
		CapitalizeFirstPipe,
		HeaderComponent,
		FooterComponent
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LoaderInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LogInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RequestInterceptor,
			multi: true
		}
	]
})
export class CoreModule {
}
